import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/i18n/locales/en.json";
import hi from "@/i18n/locales/hi.json";

// Multilingual infrastructure is kept in place for future use, but the public
// site is English-only for now: the switcher is not rendered and the stored
// language preference is ignored so the site always boots in English.
export const PUBLIC_I18N_ENABLED = false;

const STORAGE_KEY = "ptf_lang";
const stored = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, hi: { translation: hi } },
    lng: PUBLIC_I18N_ENABLED && stored === "hi" ? "hi" : "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export const setLanguage = (lng) => {
  if (!PUBLIC_I18N_ENABLED) return;
  i18n.changeLanguage(lng);
  if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, lng);
};

export default i18n;
